// extracted by mini-css-extract-plugin
export default {"preloader":"appPreloader_preloader__PMtgj"};